/**
 * Golden Hour product page behaviour.
 *
 * 1. Gold shine on the add-to-cart button: once after the shopper picks an
 *    option, then quietly every 8 seconds. Mouse users also get it on hover
 *    (CSS). Off entirely with prefers-reduced-motion.
 * 2. Links to a question row (href="#ghw-faq-...") open that <details>.
 * 3. Colour cards further down tick that colour in the picker above.
 */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var timer = null;

  function button() {
    return document.querySelector('add-to-cart-component .button');
  }

  function shine() {
    var b = button();
    if (!b || b.disabled) return;
    b.classList.remove('ghw-shine');
    void b.offsetWidth;
    b.classList.add('ghw-shine');
  }

  function startLoop() {
    if (reduce) return;
    shine();
    if (timer) clearInterval(timer);
    timer = setInterval(shine, 8000);
  }

  function onChange(event) {
    var input = event.target;
    if (!input || input.type !== 'radio' || !input.closest('.variant-picker')) return;
    startLoop();
  }

  /* 3. A colour card lower on the page (ghw-showcase) ticks that colour in
        the picker above and brings her back to it, so the size she already
        chose stays chosen. If the picker has no such colour, the card is an
        ordinary link to the variant. */
  function pickColour(event) {
    var card = event.target.closest('a[data-ghw-colour]');
    if (!card) return false;
    var colour = card.getAttribute('data-ghw-colour');
    var radio = Array.prototype.find.call(
      document.querySelectorAll('.variant-picker input[type="radio"]'),
      function (i) { return i.value === colour; }
    );
    if (!radio) return false;
    event.preventDefault();
    if (!radio.checked) radio.click();
    var fieldset = radio.closest('fieldset') || radio;
    fieldset.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    return true;
  }

  function onClick(event) {
    if (pickColour(event)) return;
    var link = event.target.closest('a[href^="#ghw-faq"]');
    if (!link) return;
    var row = document.getElementById(link.getAttribute('href').slice(1));
    if (row && row.tagName === 'DETAILS') row.open = true;
  }

  document.addEventListener('change', onChange);
  document.addEventListener('click', onClick);
})();
